import React from 'react';
import { StyleSheet, View } from 'react-native';
import theme from 'shared/styles/theme';
import { Maybe } from 'shared/utils/types';

import StackedTextAccessory, {
  StackedTextAccessoryProps,
} from './StackedTextAccessory';

type AccessoryProps = Omit<StackedTextAccessoryProps, 'alignment'>;

export interface StackedTextAccessoriesProps {
  leadingAccessory?: Maybe<AccessoryProps>;
  trailingAccessory?: Maybe<AccessoryProps>;
}

const StackedTextAccessories = ({
  leadingAccessory,
  trailingAccessory,
}: StackedTextAccessoriesProps) => {
  if (!leadingAccessory && !trailingAccessory) {
    return null;
  }

  // if one accessory is not present replace with empty <View />
  // this allows flexbox to preserve the space between the present accessory
  // and the placeholder correctly without modifying the styles
  return (
    <View style={styles.container} testID="stacked-text-accessory">
      {leadingAccessory ? (
        <StackedTextAccessory alignment="leading" {...leadingAccessory} />
      ) : (
        <View />
      )}
      {trailingAccessory ? (
        <StackedTextAccessory alignment="trailing" {...trailingAccessory} />
      ) : (
        <View />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'flex-end',
    flexDirection: 'row',
    gap: theme.spacing.m,
    justifyContent: 'space-between',
  },
});

export default StackedTextAccessories;
